import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from './ui/dropdown-menu';
import { MoreHorizontal, Pencil, Trash2, Eye } from 'lucide-react';

export default function RowActions({ onView, onEdit, onDelete, extraItems, extraCount = 0, disableEdit, disableDelete, disabledReason }) {
  // Count visible menu items to hint the user there's more behind the kebab
  const count = (onView ? 1 : 0) + (onEdit ? 1 : 0) + (onDelete ? 1 : 0) + extraCount;
  const label = count > 0 ? `${count} action${count > 1 ? 's' : ''}` : 'Plus d\'actions';
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          onClick={(e) => e.stopPropagation()}
          title={label}
          aria-label={label}
          className="group/kebab relative w-8 h-8 rounded-lg hover:bg-[#EEF2FF] flex items-center justify-center text-[#8E8FA5] hover:text-[#4F46E5] transition-colors"
        >
          <MoreHorizontal className="w-4 h-4" />
          {count > 0 && (
            <span
              className="pointer-events-none absolute top-[-4px] right-[-4px] min-w-[14px] h-[14px] px-[3px] rounded-full bg-[#4F46E5] text-white text-[9px] font-bold flex items-center justify-center opacity-0 group-hover/kebab:opacity-100 transition-opacity"
              aria-hidden="true"
            >
              {count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 rounded-xl">
        {onView && (
          <DropdownMenuItem onClick={(e) => { e.stopPropagation(); onView(); }}>
            <Eye className="w-4 h-4 mr-2" /> Voir le détail
          </DropdownMenuItem>
        )}
        {onEdit && (
          <DropdownMenuItem
            disabled={disableEdit}
            onClick={(e) => { e.stopPropagation(); if (!disableEdit) onEdit(); }}
            title={disableEdit ? disabledReason : undefined}
            className={disableEdit ? 'opacity-50 cursor-not-allowed' : ''}
          >
            <Pencil className="w-4 h-4 mr-2" /> {disableEdit ? 'Verrouillé 🔒' : 'Modifier'}
          </DropdownMenuItem>
        )}
        {extraItems}
        {onDelete && <DropdownMenuSeparator />}
        {onDelete && (
          <DropdownMenuItem
            disabled={disableDelete}
            onClick={(e) => { e.stopPropagation(); if (!disableDelete) onDelete(); }}
            title={disableDelete ? disabledReason : undefined}
            className={`${disableDelete ? 'opacity-50 cursor-not-allowed' : ''} text-[#EF4444] focus:text-[#EF4444]`}
          >
            <Trash2 className="w-4 h-4 mr-2" /> {disableDelete ? 'Verrouillé 🔒' : 'Supprimer'}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
